export const getTotalScoreColor = (firstScore: number, secondScore: number) => {
    return firstScore > secondScore ? 'success.dark' : firstScore === secondScore ? 'default' : 'error.dark'
}

export const getScoreColor = (score: number) => {
    return score === 1 ? 'success.dark' : score === 0 ? 'error.dark' : 'default'
}
